import { useEffect, useState } from "react";

/** The clock, a minute at a time, so "resets in 3 hours" and "2 hours ago" move on. */
export function useNow(): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const tick = setInterval(() => setNow(Date.now()), 60_000);
    return () => clearInterval(tick);
  }, []);
  return now;
}
